<template>
  <div class="popup z-index-10-fg confirmation small-popup add-interaction-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Report Filters</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />
      </div>
      <div class="popup-body">
        <MultiDropdown :options="sortedColumnsList" :label="'Columns'" :showSelectAll="true" v-model="filters.columns" class="input-item" />
        <TextBox label="Company Name" v-model="filters.name" class="input-item" />
        <MultiDropdown :options="pickLists.categories.items.map((item) => item.NAME)" :label="'Categories'" :showSelectAll="true" v-model="filters.categories" class="input-item" />
        <MultiDropdown
          :options="salespeople.map((salesperson) => ({ key: salesperson.USERID, value: salesperson.DISPLAYNAME }))"
          :label="'Inside Salespeople'"
          :showSelectAll="true"
          v-model="filters.insideSalespeople"
          class="input-item" />
        <MultiDropdown
          :options="outsideSalespeople.map((salesperson) => ({ key: salesperson.USERID, value: salesperson.DISPLAYNAME }))"
          :label="'Outside Salespeople'"
          :showSelectAll="true"
          v-model="filters.outsideSalespeople"
          class="input-item" />
        <MultiDropdown :options="pickLists.customerDetail.items.map((item) => item.NAME)" :label="'Customer Details'" :showSelectAll="true" v-model="filters.customerDetails" class="input-item" />
        <MultiDropdown :options="pickLists.vendorDetails.items.map((item) => item.NAME)" :label="'Vendor Details'" :showSelectAll="true" v-model="filters.vendorDetails" class="input-item" />
        <MultiDropdown :options="pickLists.vendorDepartments.items.map((item) => item.NAME)" :label="'Vendor Departments'" :showSelectAll="true" v-model="filters.vendorDepartments" class="input-item" />
        <MultiDropdown :options="pickLists.architectDetails.items.map((item) => item.NAME)" :label="'Architect/Engineer Details'" :showSelectAll="true" v-model="filters.architectDetails" class="input-item" />
        <MultiDropdown :options="stateList" :label="'States'" :showSelectAll="true" v-model="filters.states" class="input-item" />
        <TextBox label="City" v-model="filters.city" class="input-item" />
        <TextBox label="Zip Code" v-model="filters.zip" class="input-item" />
      </div>
      <div class="popup-footer">
        <button @click="resetFilters" class="text-btn">reset filters</button>
        <button @click="$emit('closePopup')" class="text-btn">close</button>
        <button :class="{ 'square-btn': true, saving: loading }" @click="saveAndRun" :disabled="loading">save & run <img src="../assets/spinner.svg" /></button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import MultiDropdown from './inputs/MultiDropdown.vue';
import TextBox from './inputs/TextBox.vue';
import Checkbox from './inputs/Checkbox.vue';
import useCompanyReportQuery from '@/composables/useCompanyReportQuery';
import useUsersQuery from '@/composables/useUsersQuery';
import usePicklistItemsQuery from '@/composables/usePicklistItemsQuery';

export default {
  name: 'CompanyReportFilter',
  emits: ['closePopup'],
  components: {
    MultiDropdown,
    TextBox,
    Checkbox,
  },
  setup() {
    const { filters, columnsList, runReport, stateList, loading, validateFilters, resetFilters } = useCompanyReportQuery();
    const { salespeople, outsideSalespeople } = useUsersQuery();
    const { pickLists } = usePicklistItemsQuery;

    return {
      filters,
      columnsList,
      runReport,
      salespeople,
      outsideSalespeople,
      pickLists,
      stateList,
      loading,
      validateFilters,
      resetFilters,
    };
  },
  computed: {
    sortedColumnsList() {
      return this.columnsList.sort((a, b) => a.order - b.order).map((item) => ({ key: item.name, value: item.title }));
    },
  },
  methods: {
    saveAndRun() {
      if (!this.validateFilters()) return;

      this.$emit('closePopup');
      this.runReport();
    },
  },
};
</script>

<style lang="scss" scoped>
.add-interaction-popup {
  width: 40rem;
  max-height: 90vh;
  overflow-y: auto;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .popup-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1.5rem 1rem;

    .input-item {
      min-width: 15rem;
      flex: 1 0 40%;
    }
  }
}
</style>
